import { useContext } from "react"
import { useVoice } from "../context/voice/VoiceContext"
import Button from "../formfields/Button"
import { GlobalContext } from "../GlobalContext"


type Props = {

}

function VoiceModeToggle({ }: Props) {


    const {
        isListening,
        isRecognizerRunning,
        speechRecognitionSupported,
        startListening,
        stopListening,
        isListeningEnabled,
        setIsListeningEnabled
    } = useVoice()

    const { isRTL, t } = useContext(GlobalContext)

    if (!speechRecognitionSupported()) {
        return null
    }

  

    return <Button
        onClick={() => {
            if (isListeningEnabled) {
                setIsListeningEnabled(false)
                localStorage.setItem('savedVoiceOption', 'no')
            } else {
                setIsListeningEnabled(true)
                localStorage.setItem('savedVoiceOption', 'yes')
            }
        }}
        text={isListeningEnabled ? 
            t('VoiceModeToggle.disable') : 
            t('VoiceModeToggle.enable')}
        variant={isListeningEnabled ? `white` : `primary`}
        align={isRTL ? 'right' : 'left'}
        size={'big'}
    />

}

export default VoiceModeToggle